import { RuleObject } from 'antd/lib/form';
import { TFunctionResult } from 'i18next';

const numericValidator = (input: string): boolean => /^\d+$/.test(input);

// TODO: check if removing 'rule' breaks any usage of the function
export const validateZipCode = (
  _rule: RuleObject,
  value: string,
  callback: (value: string) => TFunctionResult
) => {
  if (!value) {
    return Promise.reject(callback('VALIDATION_MESSAGE.ZIP_CODE_EMPTY'));
  }
  if (!numericValidator(value)) {
    return Promise.reject(
      callback('VALIDATION_MESSAGE.ZIP_CODE_NUMERIC_INPUT')
    );
  }
  if (value.length < 5) {
    return Promise.reject(callback('VALIDATION_MESSAGE.ZIP_CODE_LESS_5DIGITS'));
  }
  if (value.length > 5) {
    return Promise.reject(callback('VALIDATION_MESSAGE.ZIP_CODE_MORE_5DIGITS'));
  }

  return Promise.resolve('');
};

export const validateZipCodeSync = (value: string) => {
  const zipCodeValidations: [boolean, string][] = [
    [!value, 'VALIDATION_MESSAGE.ZIP_CODE_EMPTY'],
    [!numericValidator(value), 'VALIDATION_MESSAGE.ZIP_CODE_NUMERIC_INPUT'],
    [value.length < 5, 'VALIDATION_MESSAGE.ZIP_CODE_LESS_5DIGITS'],
    [value.length > 5, 'VALIDATION_MESSAGE.ZIP_CODE_MORE_5DIGITS'],
  ];

  return zipCodeValidations.find(([match]) => match)?.[1] ?? '';
};

export const handleNumberInput = (
  e: React.KeyboardEvent<HTMLInputElement>,
  additionalKeys: string[] = []
) => {
  // Allow: backspace, delete, tab, escape, enter, decimal point
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Enter',
    'Escape',
    'ArrowLeft',
    'ArrowRight',
    'ArrowDown',
    'ArrowUp',
  ];

  // Allow number keys (0-9)
  const isNumber = /^[0-9]$/.test(e.key);

  // Block the key press if it's not allowed
  if (
    !isNumber &&
    !allowedKeys.includes(e.key) &&
    !additionalKeys.includes(e.key)
  ) {
    e.preventDefault();
  }
};

export const handleIntegerNumberInput = handleNumberInput;

export const handleDecimalNumberInput = (
  event: React.KeyboardEvent<HTMLInputElement>
): void => {
  handleNumberInput(event, ['.']);
};
